(function () {
  "use strict";

  angular.module("sempraWebapp").component("alertHistory", {
    templateUrl: "app/facilityKarcherDetails/alertHistory/alertHistory.html",
    controller: alertHistory,
    bindings: {
      facilityId: "<",
      facilityName: "<"
    },
    controllerAs: "vm"
  });

  function alertHistory(
    dashboardKarcherActions,
    $translate,
    layoutActions,
    reportExportUtil,
    exportToCsv,
    localeFilters,
    helperService
  ) {
    var vm = this;
    // Grid data
    setGridData();

    vm.$onInit = function () {
      if (vm.facilityId) {
        refreshHistoryAlarmList();
      }
    };

    vm.$onChanges = function () {
      if (vm.facilityId) {
        refreshHistoryAlarmList();
      }
    };

    vm.pageChanged = function (page, limit) {
      vm.alarmsPage = page;
      vm.alarmsPageSize = limit;
      refreshHistoryAlarmList();
    };

    vm.sortChanged = function (order) {
      var orderQuery = getOrderObject(order);
      vm.alarmsOrderBy = orderQuery.orderBy;
      vm.alarmsOrder = orderQuery.order;
      refreshHistoryAlarmList();
    };

    vm.refreshAlertPage = function () {
      setGridData();
      refreshHistoryAlarmList();
    };

    vm.downloadCsv = function () {
      getDataForCSVDownload(vm.alarmsTotal).then(function (csvData) {
        var updatedData = {
          groupNames: [
            $translate.instant("ALERT_CODE"),
            $translate.instant("COMPANY_NAME"),
            $translate.instant("SITE_NAME"),
            $translate.instant("FACILITY_NAME"),
            $translate.instant("ALERT_NAME"),
            $translate.instant("ALERT_DESCRIPTION"),
            $translate.instant("STATUS")
          ],
          groupTotal: [],
          groupsData: csvData.content.map(function (item) {
            return {
              groupValue: localeFilters.hourly(item.timestamp),
              values: [].concat(
                item.karcherFault.number,
                item.companyName,
                item.siteName,
                item.washFacilityName,
                item.karcherFault.name,
                item.karcherFault.description,
                item.status
                  ? $translate.instant("RESOLVED_STATUS")
                  : $translate.instant("NOT_RESOLVED_STATUS")
              )
            };
          })
        };
        var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant("DATE"),
          updatedData,
          reportExportUtil.ValueFormattersEnum.DEFAULT,
          reportExportUtil.ValueFormattersEnum.DEFAULT
        );

        exportToCsv.export(
          jsonArrayForExport,
          vm.facilityName + $translate.instant("ALARM_HISTORY"),
          true
        );
      });
    };

    function setGridData() {
      vm.alarmsOrderBy = "timestamp";
      vm.alarmsOrder = "desc";
      vm.alarmsPage = 1;
      vm.alarmsTotal = 0;
      vm.alarmsPageSize = 10;
      vm.alarmsPageOptions = [5, 10, 15, 50, 100];
      vm.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };
    }

    function refreshHistoryAlarmList() {
      layoutActions.showLoader();
      dashboardKarcherActions
        .getKarcherAlarmsHistoryList(
          "",
          vm.facilityId,
          "",
          "",
          vm.alarmsPage - 1,
          vm.alarmsPageSize,
          helperService.orderByRemover(vm.alarmsOrderBy),
          vm.alarmsOrder
        )
        .then(function (data) {
          if (data.content.length === 0) {
            vm.alarmList = [];
            vm.alarmList.push({
              timestamp: $translate.instant("NOTHING_TO_DISPLAY"),
              displayNotResolve: true
            });
          } else {
            vm.alarmList = setStateIcon(data.content, false);
          }
          vm.alarmsTotal = data.totalElements;
          layoutActions.hideLoader();
        });
    }

    function getDataForCSVDownload(totalNumberOfElements) {
      layoutActions.showLoader();
      return dashboardKarcherActions
        .getKarcherAlarmsHistoryList(
          "",
          vm.facilityId,
          "",
          "",
          vm.alarmsPage - 1,
          totalNumberOfElements,
          vm.alarmsOrderBy,
          vm.alarmsOrder
        )
        .then(function (data) {
          layoutActions.hideLoader();
          return data;
        });
    }

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    function setStateIcon(data, switcher) {
      for (var i = 0; i < data.length; i++) {
        var caseItem = switcher
          ? data[i].status
          : data[i].karcherFault.washFacilityStatus;
        switch (caseItem) {
          case "INFO":
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
          case "WARNING":
            data[i].icon = "assets/icons/ic_medium_alarm.svg";
            break;
          case "ALARM":
            data[i].icon = "assets/icons/ic_high_alarm.svg";
            break;
          default:
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
        }
      }
      return data;
    }
  }
})();
